import {
  PayState,
  PayMethod,
  PayCurrency,
  ChooseMethodAction,
  ShowAction,
  SetAmountAction,
  SetAvailableMethodsAction,
  SetRatesAction,
  TopUpMethod,
} from './interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';

const initialState: PayState = {
  isActive: false,
  title: 'Pay',
  description: '',
  payUrl: '',
  payConfirmUrl: '',
  invoiceId: null,
  isWaitingForPay: false,
  randomInvoiceId: null,
  invoiceToken: null,
  isFailed: false,
  errorCode: null,
  availableMethods: [PayMethod.BALANCE, PayMethod.CARD],
  availableCurrencies: [PayCurrency.TON, PayCurrency.BTC, PayCurrency.USDT],
  amount: 0,
  loadingRates: false,
  rates: {},
  topUpMethods: [],
  topUpMethodsLoading: false,
};

export const { actions, reducer } = createSlice({
  name: 'pay',
  initialState,
  reducers: {
    getRates() {},
    setIsFailed(state, action: PayloadAction<boolean>) {
      state.isFailed = action.payload;
    },
    setErrorCode(state, action: PayloadAction<string | null>) {
      state.errorCode = action.payload;
    },
    setIsWaitingForPay(state, action: PayloadAction<boolean>) {
      state.isWaitingForPay = action.payload;
    },
    setRandomInvoiceId(state, action: PayloadAction<number>) {
      state.randomInvoiceId = action.payload;
    },
    setPayUrl(state, action: PayloadAction<string>) {
      state.payUrl = action.payload;
    },
    setPayConfirmUrl(state, action: PayloadAction<string>) {
      state.payConfirmUrl = action.payload;
    },
    setInvoiceId(state, action: PayloadAction<number>) {
      state.invoiceId = action.payload;
    },
    setInvoiceToken(state, action: PayloadAction<string | null>) {
      state.invoiceToken = action.payload;
    },
    setLoadingRates(state, action: PayloadAction<boolean>) {
      state.loadingRates = action.payload;
    },
    setRates(state, action: SetRatesAction) {
      state.rates = {
        ...state.rates,
        ...action.payload,
      };
    },
    chooseMethod(_, action: ChooseMethodAction) {},
    setAmount(state, action: SetAmountAction) {
      state.amount = action.payload;
    },
    setAvailableMethods(state, action: SetAvailableMethodsAction) {
      state.availableMethods = action.payload;
    },
    show(state, action: ShowAction) {
      state.isActive = true;
      state.title = action.payload.title || '';
      state.description = action.payload.description || '';
    },
    cancel(state) {
      state.isActive = false;
      state.payUrl = '';
      state.invoiceId = null;
      state.title = '';
      state.description = '';
      state.invoiceToken = null;
      state.amount = 0;
    },
    loadTopUpMethods(state) {
      state.topUpMethodsLoading = true;
    },
    setTopUpMethods(state, action: PayloadAction<TopUpMethod[]>) {
      state.topUpMethods = action.payload;
      state.topUpMethodsLoading = false;
    },
    setTopUpMethodsLoading(state, action: PayloadAction<boolean>) {
      state.topUpMethodsLoading = action.payload;
    },
  },
});

export { reducer as payReducer, actions as payActions };

export const paySelector = (state: RootState) => state.pay;
